import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import index from '@/pages/index/index'
import login from '@/pages/user/login'
import profitDetail from '@/pages/car/profitDetail'
import MessageList from '@/pages/message/MessageList'
import messageDetails from '@/pages/message/messageDetails'
import carSetting from '@/pages/car/carSetting'
import addCar from '@/pages/car/addCar'
import calendar from '@/pages/car/calendar'
import cityList from '@/pages/car/cityList'
import orderList from '@/pages/order/orderList'
import userCenter from '@/pages/user/userCenter'
import wallet from '@/pages/user/wallet'
import withdraw from '@/pages/user/withdraw'
import personalSetting from '@/pages/user/personalSetting'
import selectAddress from '@/pages/car/selectAddress'
import peccancy from '@/pages/car/peccancy'
import accident from '@/pages/car/accident'
import maintain from '@/pages/car/maintain'
import invite from '@/pages/index/invite'
import rule from '@/pages/index/rule'
import applySuccess from '@/pages/car/applySuccess'
import applylist from '@/pages/index/applylist';


Vue.use(Router);

const router = new Router({
  mode: 'history', //history模式去掉锚点#
  routes: [{
      path: '/',
      redirect: 'index' //路由重定向
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        isLogin: true,
        title: "大方租车",
        background: "blue"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        isLogin: false,
        title: "登录",
        back: "index"
      }
    },
    {
      path: '/profitDetail',
      name: 'profitDetail',
      component: profitDetail,
      meta: {
        isLogin: true,
        title: "收益详情",
        back: "",
        background: "blue"
      }
    },
    {
      path: '/MessageList',
      name: 'MessageList',
      component: MessageList,
      meta: {
        isLogin: true,
        title: "消息列表",
        back: "index"
      }
    },
    {
      path: '/messageDetails',
      name: 'messageDetails',
      component: messageDetails,
      meta: {
        isLogin: true,
        title: "消息详情",
        back: "MessageList"
      }
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: userCenter,
      meta: {
        isLogin: true,
        title: "个人中心",
        back: "index",
        background: "blue"
      }
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        isLogin: true,
        title: "钱包",
        back: "userCenter",
        background: "blue"
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta: {
        isLogin: true,
        title: "提现",
        back: "wallet"
      }
    },
    {
      path: '/carSetting',
      name: 'carSetting',
      component: carSetting,
      meta: {
        isLogin: true,
        title: "车辆管家",
        back: "index",
        background:'blue'
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: calendar,
      meta: {
        isLogin: true,
        title: "车辆设置",
        back: ""
      }
    },
    {
      path: '/addCar',
      name: 'addCar',
      component: addCar,
      meta: {
        isLogin: true,
        title: "添加车辆"
      }
    },
    {
      path: '/cityList',
      name: 'cityList',
      component: cityList,
      meta: {
        isLogin: true,
        title: "城市列表",
        back: "addCar"
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        isLogin: true,
        title: "订单列表",
        back: "index",
        background:"blue"
      }
    },
    {
      path: '/personalSetting',
      name: 'personalSetting',
      component: personalSetting,
      meta: {
        isLogin: true,
        title: "个人设置",
        back: "",
        background: ""
      }
    },
    {
      path: '/peccancy',
      name: 'peccancy',
      component: peccancy,
      meta: {
        isLogin: true,
        title: "违章记录",
        back: ""
      }
    },
    {
      path: '/accident',
      name: 'accident',
      component: accident,
      meta: {
        isLogin: true,
        title: "事故记录",
        back: ""
      }
    },
    {
      path: '/maintain',
      name: 'maintain',
      component: maintain,
      meta: {
        isLogin: true,
        title: "保养记录",
        back: ""
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: invite,
      meta: {
        isLogin: true,
        title: "邀请车主",
        back: "index"
      }
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule,
      meta: {
        isLogin: true,
        title: "邀请规则",
        back: ""
      }
    },
    {
      path: '/selectAddress',
      name: 'selectAddress',
      component: selectAddress,
      meta: {
        isLogin: true,
        title: "选择地址",
        back: "addCar"
      }
    },
    {
      path: '/applySuccess',
      name: 'applySuccess',
      component: applySuccess,
      meta: {
        isLogin: true,
        title: "申请成功",
        back: "index"
      }
    },
    {
      path: '/applylist',
      name: 'applylist',
      component: applylist,
      meta: {
        isLogin: true,
        title: "申请记录",
        back: "index"
      }
    },
    {
      path: '*',
      redirect: 'index' //404页面重定向为首页
    },
  ]
});

router.beforeEach((to, from, next) => {
  if( window.localStorage.getItem("token") ){
    if (Vue.prototype.source) {
      const CancelToken = axios.CancelToken;
      Vue.prototype.source.cancel && Vue.prototype.source.cancel("取消请求");
      Vue.prototype.source = CancelToken.source();
    }
    if (to.meta.title) { document.title = to.meta.title; }
    if (from.name != "authLogin" && from.name != "normalLogin") {
      Vue.prototype.prevPath = from.fullPath;
    }
  } else {
    if( to.meta.isLogin ){
      next({
        path: '/login',
        query: { redirect_uri: to.fullPath }
      });
    }
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/router.js